import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { PaymentMethodProps } from './paymentMethodsTypes';

const paymentMethodsPayloadCreator = getPayloadCreator<void, PaymentMethodProps>();
const paymentMethodsSuccessPayloadCreator = getPayloadCreator<
  QcsSyncResourcesPayload<PaymentMethodProps>,
  PaymentMethodProps
>();
const paymentMethodsFailurePayloadCreator = getFailurePayloadCreator<unknown, Meta<PaymentMethodProps>>();

export const getPaymentMethods = createAction('GET_PAYMENT_METHODS', paymentMethodsPayloadCreator);
export const getPaymentMethodsSuccess = createAction(
  'GET_PAYMENT_METHODS_SUCCESS',
  paymentMethodsSuccessPayloadCreator,
);
export const getPaymentMethodsFailure = createAction(
  'GET_PAYMENT_METHODS_FAILURE',
  paymentMethodsFailurePayloadCreator,
);
